import styled from '@emotion/styled';

export const MarketIdWrapper = styled('div', { label: 'MarketIdWrapper' })`
    display: flex;
`;

export const InputMarketWrapper = styled('div', { label: 'InputMarketWrapper' })`
    margin: 0 0 5px;
    position: relative;
    border-radius: 3px;
    cursor: default;
`;

export const InputMarketId = styled('input', { label: 'InputMarketId' })`
    padding: 14px 12px 0 12px;
    border: 1px solid #ccc;
    width: 100%;
    height: 40px;
    outline: none;
    border-radius: 3px;
    font-weight: 600;
    color: #888;
    pointer-events: none;
`;

export const LabelMarketId = styled('label', { label: 'LabelMarketId' })`
    font-size: 10px;
    font-weight: 400;
    position: absolute;
    left: 12px;
    color: #666;
`;

export const CopyWrapper = styled('div', { label: 'CopyWrapper' })`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    margin-left: 8px;
    border-radius: 3px;
    border: 1px solid #ccc;
    padding: 8px 20px;
    color: #888;
    font-weight: bold;
    cursor: pointer;
`;
